import { getRandomFromArray } from '../theme/utils'

export const getUserName = (user) => {
  if (!user) { return getRandomFromArray(['chief', 'buddy', 'sport', 'pal', 'bruh']) }
  return user.full_name || user.username || user.email
}
